import { render, staticRenderFns } from "./premium-form.vue?vue&type=template&id=11ffeae4&scoped=true&"
import script from "./premium-form.vue?vue&type=script&lang=js&"
export * from "./premium-form.vue?vue&type=script&lang=js&"
import style0 from "./premium-form.vue?vue&type=style&index=0&id=11ffeae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffeae4",
  null
  
)

export default component.exports